import { defineMessages } from 'react-intl';

export default defineMessages({
    autoLogoutTitle: {
        id: 'ent.ac.portal.autologout.Title',
        defaultMessage: 'Session Timeout',
    },
    autoLogoutBody: {
        id: 'ent.ac.portal.autologout.Body',
        defaultMessage: 'Warning, your session is about to expire.',
    },
    autoLogoutContinue: {
        id: 'ent.ac.portal.autologout.Continue',
        defaultMessage: 'Continue Session',
    },
});
